import React from 'react'
import { Outlet } from 'react-router-dom'

function VerifyIdentityParent() {
    return (
        <div>
            <Outlet/>
        </div>
    )
}

export default VerifyIdentityParent
